/*
 * Project: bellcloud
 * File: packages/types/device/common/gas_conc_units.ts
 * Author: SWAN
 * Created: 2025-07-08
 * Description: gas concentration unit 정의 (TypeScript)
 */

import type { Option } from '../../common/option';

export enum GasConcUnit {
  PPM = 0,
  VOL = 1,
  LEL = 2,
  UNKNOWN = 255,
}

export type GasConcUnitOption = Option<GasConcUnit>;

export const GAS_CONC_UNIT_OPTIONS: Record<GasConcUnit, GasConcUnitOption> = {
  [GasConcUnit.PPM]: { value: GasConcUnit.PPM, label: 'PPM' },
  [GasConcUnit.VOL]: { value: GasConcUnit.VOL, label: '%VOL' },
  [GasConcUnit.LEL]: {
    value: GasConcUnit.LEL,
    label: '%LEL',
  },
  [GasConcUnit.UNKNOWN]: {
    value: GasConcUnit.UNKNOWN,
    label: 'Unknown',
  },
};
